<template>
  <div class="parameter-manage">
    <second-menu-link-content>
      <template v-slot:header>
        <span>参数管理</span>
      </template>
      <template v-slot:content>
        <div class="parameter-manage-main">
          <div class="left">
            <div class="top-search">
              <el-input
                class="white w320"
                placeholder="请输入参数组名"
                @keyup.enter.native="searchParameterGroup"
                v-model="parameterNameGroupSearch"
              >
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="parameter-group">
              <div
                v-for="(item, index) in parameterGroupList"
                :key="item.id"
                :class="
                  activeIndex === index
                    ? 'active parameter-group-row'
                    : 'parameter-group-row'
                "
                @click="selecd(index, item.id)"
              >
                <span v-if="item.isModifyParameterGroupName" class="parameter-group-row-content">
                  {{ `${item.name}(${item.nums})` }}
                  <i v-if="index !== 0" class="el-icon-edit-outline" @click="modifyParameterGroupName(item, index)"></i>
                </span>
                <el-input
                  v-else
                  :ref="'modifyParameterGroupName' + index"
                  class="white"
                  v-model="item.name"
                  placeholder="请输入参数组名"
                  @keyup.enter.native="modifyParameterGroupNameInputConfirm(item)"
                  @blur="modifyParameterGroupNameInputConfirm(item)"
                >
                </el-input>
              </div>
              <el-input
                v-if="inputVisible"
                class="white input-new-parameterGroupName"
                v-model="inputValue"
                placeholder="请输入参数组名"
                @keyup.enter.native="addInputConfirm"
                @blur="addInputConfirm"
              >
              </el-input>
            </div>
            <div class="add-parameter-group">
              <el-button class="btn-blue" @click="addParameterGroup">新增参数组</el-button>
            </div>
          </div>
          <div class="right">
            <div class="parameter-search">
              <div class="add-parameter-manage">
                <el-button v-if="activeIndex === 0" class="btn-blue" @click="add">新增参数</el-button>
                <el-button v-if="activeIndex === 0" class="btn-white" @click="moveParameterGroup">移动参数名</el-button>
                <el-button v-if="activeIndex !== 0" class="btn-blue" @click="deleteParameterGroup">删除参数组</el-button>
              </div>
              <el-input
                class="white w320"
                placeholder="请输入参数名"
                @keyup.enter.native="searchParameter"
                v-model="parameterNameSearch"
              >
                <i slot="suffix" class="el-input__icon el-icon-search"  @click="searchParameter"></i>
              </el-input>
            </div>
            <div class="table" ref="table">
              <el-table :data="tableData" style="width: 100%">
                <el-table-column
                  prop="parameterName"
                  label="参数名"
                  width="200"
                ></el-table-column>
                <el-table-column
                  prop="weight"
                  label="权重"
                  width="120"
                ></el-table-column>
                <el-table-column
                  prop="parameterValueStr"
                  label="参数值"
                ></el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="scope">
                    <el-button
                      v-if="activeIndex === 0"
                      class="btn-text"
                      type="text"
                      @click="change(scope.row, scope.$index)"
                      >修改</el-button
                    >
                    <el-button
                      v-if="activeIndex === 0"
                      class="btn-text"
                      type="text"
                      @click="remove(scope.row.id, scope.$index)"
                      >
                      删除
                    </el-button>
                    <el-button
                      v-else
                      class="btn-text"
                      type="text"
                      @click="postRemoveParameter(scope.row.id, scope.$index)"
                      >
                      移除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="page">
              <pagination-tpl
                :pageSize="pageSize"
                :total="total"
                :currentPage="page"
                @queryChange="updatePage"
              ></pagination-tpl>
            </div>
          </div>
          <el-dialog
            :title="isUpdate ? '修改参数' : '新增参数'"
            :visible.sync="dialogVisible"
            width="600px"
            top="25vh"
          >
            <!-- 黑色的线条 -->
            <div class="border"></div>
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="参数名：" prop="parameterName">
                <el-input
                  v-model="ruleForm.parameterName"
                  class="gray"
                  placeholder="请输入参数名"
                ></el-input>
              </el-form-item>
              <el-form-item label="权重：" prop="weight">
                <el-input
                  v-model.number="ruleForm.weight"
                  class="gray"
                  placeholder="请输入权重"
                ></el-input>
              </el-form-item>
              <el-form-item label="参数值：" prop="parameterValue">
                <div class="tag">
                  <div class="parameter-tag">
                    <el-tag
                      v-for="(tag, index) in ruleForm.parameterValue"
                      :key="tag.id"
                      :disable-transitions="true"
                      @click="modifyParameterValue(tag, index)"
                    >
                      <i class="change" @click="handleClose(index)"></i>
                      <span v-if="tag.isModifyParameterValue" class="tag-name">
                        {{ tag.value }}
                      </span>
                      <el-input
                        :ref="'modifyParameterValue'+index"
                        v-if="!tag.isModifyParameterValue"
                        v-model.trim="tag.value"
                        class="white modifyParameterValue-input"
                        @blur="modifyParameterValueInputConfirm(tag, index)"
                      >
                      </el-input>
                    </el-tag>
                  </div>
                  <el-input
                    class="input-new-tag"
                    v-if="ruleForm.inputVisible"
                    v-model.trim="ruleForm.inputValue"
                    ref="saveTagInput"
                    size="small"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                  ></el-input>
                  <el-button
                    class="btn-white"
                    v-else
                    size="small"
                    @click="showInput"
                    >+ 添加</el-button
                  >
                </div>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="btn-white"
                  type="primary"
                  @click="reset('ruleForm')"
                  >取消</el-button
                >
                <el-button class="btn-blue" @click="submit('ruleForm')"
                  >保存</el-button
                >
              </el-form-item>
            </el-form>
          </el-dialog>
          <el-dialog
            class="moveParameterName"
            title="移动参数名"
            :visible.sync="dialogMoveParameterName"
            width="800px"
            top="25vh"
          >
            <!-- 黑色的线条 -->
            <div class="border"></div>
            <div class="dialog-parameter-main">
              <div class="dialog-parameter-left">
                <div class="parameter-group">
                  <div
                    v-for="(item, index) in parameterGroupList"
                    :key="index"
                    :class="
                      activeMoveParameterNameIndex === index
                        ? 'active parameter-group-row'
                        : 'parameter-group-row'
                    "
                    @click="moveParameterNameselecd(index, item.id)"
                  >
                    {{ `${item.name}(${item.nums})` }}
                  </div>
                </div>
              </div>
              <div class="dialog-parameter-right">
                <div class="dialog-parameter-search">
                  <el-input
                    class="white dialog-parameter-input"
                    placeholder="请输入搜索内容"
                    prefix-icon="el-icon-search"
                    @keyup.enter.native="searchParameterName"
                    v-model="searchParameterNameDialog">
                    <template slot="append">
                      <el-popover
                        class="parameterGroupPopover"
                        placement="bottom"
                        width="248"
                        v-model="visible"
                        trigger="click">
                        <div class="nums">将{{ paramsIds.length }}个参数名移动到分组</div>
                        <el-select v-model="selectParameterGroupName" clearable class="white selectParameterGroupName">
                          <el-option
                            v-for="item in parameterGroupList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                        <div style="text-align: right; margin: 0;border-top: 1px solid #eee;padding-top: 12px;">
                          <el-button
                            class="btn-text"
                            type="text"
                            size="mini"
                            @click="visible = false"
                            >取消</el-button
                          >
                          <el-button class="btn-blue" size="mini" @click="selectParameterGroupNameConfirm"
                            >确定</el-button
                          >
                        </div>
                        <div slot="reference">
                          <img class="mouseMove" src="../../../../assets/commodity/mouseMove.png" alt>
                          移动到分组
                        </div>
                      </el-popover>
                    </template>
                  </el-input>
                </div>
                <div class="dialog-parameter-table">
                  <div class="table" ref="table">
                    <el-table
                      :data="defaultTableData"
                      style="width: 100%" 
                      :row-key="getRowKeys"
                      @selection-change="handleSelectionChange"
                    >
                      <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
                      <el-table-column
                        prop="parameterName"
                        label="参数名"
                        width="200"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="parameterValueStr"
                        label="参数值"
                      ></el-table-column>
                    </el-table>
                  </div>
                  <div class="page">
                    <pagination-tpl
                      :pageSize="pageSize"
                      :total="moveTotal"
                      :currentPage="movePage"
                      @queryChange="moveUpdatePage"
                    ></pagination-tpl>
                  </div>
                </div>
              </div>
            </div>
            <div slot="footer" class="dialog-parameter-foot">
              <el-button
                class="btn-white"
                type="primary"
                @click="cancel"
                >取消</el-button
              >
              <el-button class="btn-blue" @click="hold"
                >保存</el-button
              >
            </div>
          </el-dialog>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import Sortable from "sortablejs";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import DBCommodity from "models/db/commodity.js";
const dbCommodity = new DBCommodity();
export default {
  data() {
    var checkWeight = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("权重不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (value < 0 || value > 100) {
            callback(new Error("权重区间为0-100"));
          } else {
            callback();
          }
        }
      }, 0);
    };
    return {
      groupId: null,
      MoveGroupId: null,
      activeIndex: 0,
      activeIndexCopy: 0,
      activeMoveParameterNameIndex: 0,
      parameterNameGroupSearch: "",
      visible: false,
      inputVisible: false,
      inputValue: '',
      searchParameterNameDialog: "",
      selectParameterGroupName: "",
      parameterNameSearch: "",
      dialogMoveParameterName: false,
      parameterNameSearchValue: "",
      parameterGroupList: [],
      tableData: [],
      defaultTableData: [],
      ruleForm: {
        parameterName: "",
        weight: "",
        inputVisible: false,
        inputValue: "",
        parameterValue: [],
      },
      rules: {
        parameterName: [
          { required: true, message: "请输入参数名", trigger: "blur" },
        ],
        weight: [{ required: true, validator: checkWeight, trigger: "blur" }],
        parameterValue: [
          { required: true, message: "请输入参数值", trigger: "blur" },
        ],
      },
      dialogVisible: false,
      isUpdate: false, //是否为修改状态
      id: "", //修改的id
      pageSize: 0,
      total: 0,
      page: 1,
      movePageSize: 0,
      moveTotal: 0,
      movePage: 1,
      isFlag: false,
      paramsIds: [],
      selectParameterGroupList: [],
      isRemove: true,
      isAdd: true,
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl,
  },
  watch: {
    dialogVisible: {
      handler(value) {
        if (!value) {
          this.ruleForm.parameterName = "";
          this.ruleForm.weight = "";
          this.ruleForm.inputVisible = false;
          this.ruleForm.inputValue = "";
          this.ruleForm.parameterValue = [];
          this.isUpdate = false;
          this.id = "";
        }
      },
    },
  },
  created() {
    this.initParameterGroupList()
  },
  methods: {
    // 利用Sortable.js实现行拖拽
    rowDrop() {
      const tbody = document.querySelector(".parameter-tag");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({oldIndex, newIndex}) {
          let arr = _this.ruleForm.parameterValue
          const currRow = arr.splice(oldIndex, 1)[0];
          arr.splice(newIndex, 0, currRow);
          _this.ruleForm.parameterValue = []
          _this.ruleForm.parameterValue = arr
          if (!_this.isAdd) {
            let id
            let beforeId
            if (newIndex+1 === _this.ruleForm.parameterValue.length) {
              beforeId = 0
            } else {
              beforeId = _this.ruleForm.parameterValue[newIndex+1].id
            }
            id = _this.ruleForm.parameterValue[newIndex].id
            let data = {
              id,
              beforeId
            }
            dbCommodity.postDropParameter(data).then(res => {
              if (res.success) {
                _this.initGetDropAfterParameterList()
              } else {
                _this.$message.error(res.message)
              }
            })
          }
        }
      });
    },
    initGetDropAfterParameterList() {
      let paramsId = this.id
      dbCommodity.getDropAfterParameterList(paramsId).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.value = i.value
            obj.isModifyParameterValue = true
            arr.push(obj)
          })
          this.ruleForm.parameterValue = arr
          this.initParameterGroupList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //获取参数列表
    getParameterData() {
      let searchValue = this.parameterNameSearchValue;
      let currentPage = this.page;
      let groupId
      if (this.isFlag) {
        groupId = this.MoveGroupId
      } else {
        groupId = this.groupId
      }
      dbCommodity.getParamsList(searchValue, currentPage, groupId).then((res) => {
        if (res.success) {
          if (this.isFlag) {
            this.movePageSize = res.result.pageSize;
            this.moveTotal = res.result.totalNum;
          } else {
            this.pageSize = res.result.pageSize;
            this.total = res.result.totalNum;
          }
          let arr = [];
          res.result.items.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.parameterName = value.name;
            obj.weight = value.weight;
            obj.parameterValue = value.values;
            obj.parameterValueStr = "";
            value.values.map((v) => {
              obj.parameterValueStr += v.value + "; ";
            });
            obj.parameterValueStr = obj.parameterValueStr.slice(
              0,
              obj.parameterValueStr.length - 2
            );
            arr.push(obj);
          });
          if (this.isFlag) {
            this.defaultTableData = arr
          } else {
            this.tableData = arr;
          }
        }
      });
    },
    //搜索
    searchParameter() {
      this.parameterNameSearchValue = this.parameterNameSearch;
      this.page = 1;
      this.getParameterData();
    },
    /* 搜索参数组 */
    searchParameterGroup() {
      this.initParameterGroupList()
    },
    searchParameterName() {
      this.parameterNameSearchValue = this.searchParameterNameDialog;
      this.movePage = 1;
      this.getParameterData();
    },
    //翻页
    updatePage(data) {
      this.page = data.currentPage;
      this.getParameterData();
    },
    moveUpdatePage(data) {
      this.movePage = data.currentPage;
      this.getParameterData();
    },
    // 点击添加按钮
    add() {
      this.dialogVisible = true;
      this.isAdd = true;
      // this.$nextTick(() => {
      //   this.rowDrop();
      // })
    },
    //输入框权重限制
    inputPriceLimit(row, type, val) {
      let weight = val.toString().match(/^[1-9]\d*/g)
        ? val === "0"
          ? "0"
          : val.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      this.ruleForm.weight = price;
      // this.$set(this.tableData[index], "cost_price", CostPrice);
    },
    // 删除权重值
    handleClose(index) {
      this.ruleForm.parameterValue.splice(index, 1);
    },
    // 显示输入框
    showInput() {
      this.ruleForm.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    // 失去焦点进行判断
    handleInputConfirm() {
      let inputValue = this.ruleForm.inputValue;
      let reg = /^.{0,20}$/;
      let stop = false;
      this.ruleForm.parameterValue.map((value) => {
        if (value.value === inputValue) {
          stop = true;
        }
      });
      if (reg.test(inputValue)) {
        if (inputValue === "") {
          this.ruleForm.inputVisible = false;
          this.ruleForm.inputValue = "";
        } else if (stop) {
          this.$message.error("标签不能重复！");
        } else {
          if (this.isAdd) {
            this.ruleForm.parameterValue.push({
              value: inputValue,
              isModifyParameterValue: true
            });
            this.ruleForm.inputVisible = false;
            this.ruleForm.inputValue = "";
          } else {
            let data = {
              value: inputValue,
              paramId: this.id
            }
            dbCommodity.postModifyParameterName(data).then(res => {
              if (res.success) {
                this.ruleForm.parameterValue.push({
                  value: inputValue,
                  isModifyParameterValue: true
                });
                this.ruleForm.inputVisible = false;
                this.ruleForm.inputValue = "";
                this.getParameterData();
                this.initModifyParameterInfo()
              } else {
                this.$message.error(res.message)
              }
            })
          }
        }
      } else {
        this.$nextTick((_) => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
        this.$message.error("最多支持20个字符");
      }
    },
    // 重置
    reset(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    // 保存添加
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let stop = false
          let ary = []
          this.ruleForm.parameterValue.map(i => {
            ary.push(i.value)
          })
          if ((new Set(ary)).size != ary.length) {
            stop = true
          }
          if (stop) {
            this.$message.error("标签不能重复！");
            return
          }
          
          if (this.id) {
            let data = {};
            data.id = this.id;
            data.name = this.ruleForm.parameterName;
            data.weight = this.ruleForm.weight;
            data.goodsParamsValuesList = this.ruleForm.parameterValue;
            dbCommodity.postUpdateParams(data).then((res) => {
              if (res.success) {
                this.dialogVisible = false;
                this.getParameterData();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let data = {};
            data.name = this.ruleForm.parameterName;
            data.weight = this.ruleForm.weight;
            data.values = [];
            this.ruleForm.parameterValue.map((value) => {
              data.values.push(value.value);
            });
            dbCommodity.postAddParams(data).then((res) => {
              if (res.success) {
                this.dialogVisible = false;
                this.getParameterData();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除参数
    remove(id, index) {
      this.$confirm(`是否确认删除该参数`, `删除参数`, {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = {};
        data.id = id;
        dbCommodity.postDeleteParams(data).then((res) => {
          if (res.success) {
            this.initParameterGroupList();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 移除参数
    postRemoveParameter(id, index) {
      this.$confirm(`是否确认移除该参数`, `移除参数`, {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = {};
        data.id = this.groupId;
        data.paramsId = id
        dbCommodity.postRemoveParameter(data).then((res) => {
          if (res.success) {
            this.groupId = this.parameterGroupList[this.activeIndex].id
            this.isRemove = false
            this.initParameterGroupList();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 点击修改参数
    change(row, index) {
      this.isAdd = false;
      this.isUpdate = true;
      this.dialogVisible = true;
      this.id = row.id;
      this.ruleForm.parameterName = row.parameterName;
      this.ruleForm.weight = row.weight;
      this.ruleForm.inputVisible = false;
      this.ruleForm.inputValue = "";
      let arr = []
      row.parameterValue.map(i => {
        let obj = {}
        obj.id = i.id
        obj.value = i.value
        obj.isModifyParameterValue = true
        arr.push(obj)
      })
      this.ruleForm.parameterValue = arr;
      this.$nextTick(() => {
        this.rowDrop();
      })
    },
    /* 参数组点击高亮 */
    selecd(index, id) {
      this.isFlag = false
      this.isRemove = true
      this.activeIndex = index
      this.parameterGroupList.map((i,idx) =>　{
        if (index != idx) {
          i.isModifyParameterGroupName = true
        }
      })
      this.groupId = id
      this.getParameterData()
    },
    moveParameterNameselecd(index, id) {
      this.isFlag = true
      this.activeMoveParameterNameIndex = index
      this.MoveGroupId = id
      this.getParameterData()
    },
    /* 新增参数组 */
    addParameterGroup() {
      this.inputVisible = true;
      this.activeIndexCopy = this.activeIndex
      this.activeIndex = null
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    addInputConfirm() {
      if (this.inputValue) {
        let data = {
          name: this.inputValue
        }
        dbCommodity.postAddParameterGroup(data).then(res => {
          if (res.success) {
            this.activeIndex = 0
            this.initParameterGroupList()
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        this.activeIndex = this.activeIndexCopy
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    moveParameterGroup() {
      this.isFlag = true
      this.MoveGroupId = null
      this.parameterNameGroupSearch = ''
      this.dialogMoveParameterName = true
      this.getParameterData()
    },
    cancel() {
      this.isFlag = false
      this.dialogMoveParameterName = false
    },
    getRowKeys(row) {
      return row.id
    },
    handleSelectionChange(val) {
      let arr = []
      val.map(i => {
        arr.push(i.id)
      })
      this.paramsIds = arr
    },
    /* 移动参数名保存 */
    hold() {
      let data = this.selectParameterGroupList
      dbCommodity.postAddParameterGroupName(data).then(res => {
        if (res.success) {
          this.cancel()
          this.initParameterGroupList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    selectParameterGroupNameConfirm() {
      this.visible = false
      let id = this.selectParameterGroupName
      let data = {
        id: id,
        paramsIds: this.paramsIds
      }
      this.selectParameterGroupList = data
    },
    /* 获取参数组 */
    initParameterGroupList() {
      let groupName = this.parameterNameGroupSearch
      dbCommodity.getParameterGroupList(groupName).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            obj.nums = i.countParams
            obj.isModifyParameterGroupName = true
            arr.push(obj)
          })
          this.parameterGroupList = arr
          if (this.isRemove) {
            this.groupId = this.parameterGroupList[0].id
          }
          this.getParameterData()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    deleteParameterGroup() {
      this.$confirm('是否确认删除该参数组?', '删除参数组', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white'
      }).then(() => {
        if (this.groupId) {
          let data = {
            id: this.groupId
          }
          dbCommodity.postDeleteParameterGroup(data).then(res => {
            if (res.success) {
              this.activeIndex = 0
              this.initParameterGroupList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },
    /* 修改参数组名 */
    modifyParameterGroupName(row, index) {
      this.$nextTick(() => {
        setTimeout(() => {
          let str = 'modifyParameterGroupName' + index
          this.$refs[str][0].focus();
        },110)
      });
      setTimeout(() => {
        row.isModifyParameterGroupName = false
      }, 100)
    },
    modifyParameterGroupNameInputConfirm(row) {
      let data = {
        groupId: row.id,
        groupName: row.name
      }
      dbCommodity.postModifyParameterGroupName(data).then(res => {
        if (res.success) {
          row.isModifyParameterGroupName = true
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /* 修改参数值 */
    modifyParameterValue(row, index) {
      this.$nextTick(() => {
        setTimeout(() => {
          let str = 'modifyParameterValue' + index
          this.$refs[str][0].focus();
        },100)
      });
      row.isModifyParameterValue = false
    },
    modifyParameterValueInputConfirm(row, index) {
      row.isModifyParameterValue = true
      if (row.value === '') {
        this.ruleForm.parameterValue.splice(index, 1)
      } else {
        let reg = /^.{0,20}$/;
        if (reg.test(row.value)) {
          let stop = false
          let ary = []
          this.ruleForm.parameterValue.map(i => {
            ary.push(i.value)
          })
          if ((new Set(ary)).size != ary.length) {
            stop = true
          }
          if (stop) {
            this.$message.error("标签不能重复！");
            return
          }
  
          if (!this.isAdd) {
            let data = {
              valueId: row.id,
              value: row.value,
              paramId: this.id
            }
            dbCommodity.postModifyParameterName(data).then(res => {
              if (res.success) {
                this.getParameterData();
              } else {
                this.$message.error(res.message)
              }
            })
          }
        } else {
          this.$message.error("最多支持20个字符");
        }
      }
    },
    /* 修改参数时详情页的接口 */
    initModifyParameterInfo() {
      let paramId = this.id
      dbCommodity.getModifyParameterNameId(paramId).then(res => {
        if (res.success) {
          res.result.values.map(i => {
            this.ruleForm.parameterValue.map(v => {
              if (i.value === v.value) {
                v.id = i.id
              }
            })
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.parameter-manage {
  width: 100%;
  height: 100%;
  .parameter-manage-main {
    display: flex;
    justify-content: flex-start;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    .left {
      width: 240px;
      height: 1110px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      overflow: hidden;
      overflow-y: scroll;
      .top-search {
        padding: 16px;
      }
      .parameter-group {
        flex: 1;
        .parameter-group-row {
          height: 36px;
          line-height: 36px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          padding: 0px 16px;
          cursor: pointer;
          .parameter-group-row-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
        .active {
          color: #3d74f2;
          background: #f5f8fe;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            right: 0px;
            top: 6px;
            width: 4px;
            height: 24px;
            background: #3D74F2;
          }
        }
      }
      .add-parameter-group {
        margin: 16px;
        .el-button {
          width: 100%;
        }
      }
    }
    .right {
      flex: 1;
      padding: 17px;
      border-left: 1px solid #e5e5e5;
    }
    .add-parameter-manage {
      .el-button {
        width: 128px;
      }
    }
    .parameter-search {
      height: 64px;
      background: rgba(245, 247, 250, 1);
      border-radius: 4px;
      margin-bottom: 16px;
      padding-left: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .w320 {
        width: 320px;
        margin-right: 16px;
      }
    }
    .page {
      display: flex;
      justify-content: flex-end;
    }
  }
  .moveParameterName {
    .dialog-parameter-main {
      height: 376px;
      display: flex;
      justify-content: flex-start;
      border: 1px solid #EEEEEE;
      border-radius: 4px;
      .dialog-parameter-left {
        width: 176px;
        overflow-y: scroll;
        border-right: 1px solid #e5e5e5;
        padding-top: 6px;
        .parameter-group {
          .parameter-group-row {
            height: 36px;
            line-height: 36px;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            padding: 0px 16px;
            cursor: pointer;
          }
          .active {
            color: #3d74f2;
            background: #f5f8fe;
            position: relative;
            &::after {
              content: '';
              position: absolute;
              right: 0px;
              top: 6px;
              width: 4px;
              height: 24px;
              background: #3D74F2;
            }
          }
        }
      }
      .dialog-parameter-right {
        width: 591px;
        display: flex;
        flex-direction: column;
        .dialog-parameter-search {
          border-bottom: 1px solid #EEE;
          margin-bottom: 16px;
          .mouseMove {
            width: 14px;
            height: 14px;
            vertical-align: middle;
          }
        }
        .dialog-parameter-table {
          overflow-y: auto;
          padding: 0px 16px;
        }
      }
    }
  }
  .parameter-tag {
    display: inline-block;
  }
  .tag-name {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
<style lang="scss">
.parameter-manage {
  .dialog-parameter-foot {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dialog-parameter-input {
    .el-input__icon {
      line-height: 34px;
    }
    .el-input__inner {
      border-radius: 0px;
      border: 0px;
    }
    .el-input-group__append {
      background: #fff;
      border-radius: 0px;
      border: 0px;
      position: relative;
      cursor: pointer;
      &::before {
        content: '';
        position: absolute;
        top: 6px;
        left: 0px;
        height: 20px;
        width: 1px;
        background-color: #EEE;
      }
    }
  }
  .input-new-parameterGroupName {
    border-radius: 0px;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      right: 0px;
      top: 6px;
      width: 4px;
      height: 24px;
      background: #3D74F2;
    }
    .el-input__inner {
      height: 36px;
      border: none;
      color: #3d74f2;
      background: #f5f8fe;
    }
  }
  .moveParameterName {
    // 隐藏全选框
    .table .el-table .el-table__header-wrapper .el-table__header .has-gutter tr th .cell .el-checkbox {
      display: none !important;
    }
  }
  .parameter-manage-main {
    .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
      height: auto;
    }
    .el-dialog {
      border-radius: 4px;
      .el-dialog__header {
        padding: 0 24px;
        line-height: 48px;
        color: #606266;
        font-family: "PingFangSC-Medium";
        letter-spacing: 1px;
        .el-dialog__title {
          font-size: 16px;
          color: #606266;
          font-weight: 500;
        }
        .el-dialog__headerbtn {
          top: 15px;
        }
      }
      .el-dialog__body {
        padding: 0px 16px 16px 16px;
        .border {
          border-bottom: 1px solid #f7f7f7;
          margin-bottom: 16px;
        }
        .el-form {
          .el-form-item:last-child {
            margin-bottom: 0px;
          }
          .el-form-item {
            margin-bottom: 16px;
            .el-form-item__label {
              line-height: 32px;
            }
            .el-form-item__content {
              line-height: 32px;
              .el-select {
                width: 100%;
              }
              .el-form-item__error {
                padding-top: 2px;
              }
              .el-button {
                width: 96px;
              }
              .el-button.btn-blue {
                margin-left: 24px;
              }
            }
          }
        }
        .tag {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          .el-tag {
            text-align: center;
            height: 32px;
            width: 150px;
            border-radius: 4px;
            background: #fff;
            color: #919398;
            border: 1px dashed rgba(221, 223, 230, 1);
            margin-right: 5px;
            margin-bottom: 5px;
            padding: 0 5px;
            cursor: pointer;
            position: relative;
            .change {
              position: absolute;
              width: 16px;
              height: 16px;
              background: url(../../../../assets/images/remove.png);
              background-size: cover;
              top: -8px;
              right: -5px;
              display: none;
              z-index: 9999;
            }
          }
          .el-tag:hover {
            .change {
              display: block;
            }
          }
          .btn-white {
            width: 150px;
            font-size: 12px;
            margin-right: 5px;
            margin-bottom: 5px;
          }
          .none {
            display: none;
          }
          .input-new-tag {
            width: 150px;
            margin-right: 5px;
            margin-bottom: 5px;
          }
        }
      }
    }
  }
  .modifyParameterValue-input {
    overflow: hidden;
    .el-input__inner {
      height: 30px;
      border-radius: 0px;
      border: none;
    }
  }
}
</style>
<style>
.el-popover .nums {
  margin: 16px 0px;
}
.el-popover .selectParameterGroupName {
  width: 100%;
  margin-bottom: 32px;
}
</style>
